import AbstractBulkDataParser from "../../../../vendor_core/core/src/server/parsers/AbstractBulkDataParser";
import { ISpinResponseData } from "../data/ISpinResponseData";
import Utils from "../../../../vendor_core/core/src/utils/Utils";
import SymbolMap from "../../../../vendor_core/core/src/utils/SymbolMap";
import { ISymbolPosition, OverlayType } from "../../../../vendor_core/core/src/server/data/ISpinData";
import ILoginData from "../data/ILoginData";
// import * as test from "./resp.json"

export default class BBSpinDataParser extends AbstractBulkDataParser<any> {
    private flag = false;

    validateData(data: any): boolean {
        return (data.generations || data.refresh) && data.stats;
    }

    processData(source: any): any[] {
        // console.log(JSON.stringify(source));
        // source = test;


        let data: ISpinResponseData;
        let recoverData = null;
        let results = [];

        if (source.hasOwnProperty("refresh")) {
            data = (source as ILoginData).refresh;
            if (data.restoreState) {
                recoverData = JSON.parse(data.restoreState);
            }
        } else {
            data = source as ISpinResponseData;
        }

        let currentGenerationIndex = recoverData ? recoverData.generation : 0;

        if (currentGenerationIndex >= data.generations.length) {
            currentGenerationIndex = data.generations.length - 1;
        }
        const generationsData = this.parseGenerationsSymbolsData(
            Utils.deepClone(data.generations)
        );
        const currentSlice = generationsData.slice(currentGenerationIndex);
        let cascadesData: any[] = this.parseCascadeSpins(currentSlice, false);


        const result = {
            isFree: false,
            roundType: data.roundType,
            balance: data.stats ? data.stats.b : undefined,
            winAmount: generationsData[generationsData.length - 1].generationWin,
            currentWin: generationsData[generationsData.length - 1].generationWin,
            winsData: this.parseWinData(
                data.generations[data.generations.length - 1].winnings
            ),
            ended: data.ended, // round ended
            multiplier: data.generations[generationsData.length - 1].multiplier,
            stopPositions: [0, 0, 0, 0, 0, 0, 0, 0], // reel stop position
            cascades: cascadesData.slice(0, generationsData.length - 1),
            cascadeIndex: cascadesData?.length > 0 ? 0 : -1,
            // cascadeWinOffsets:cascadesData && cascadesData.length?cascadesData[cascadesData.length - 1].cascadeWinOffsets:[],
            cascadeWinOffsets: [],
            generations: data.generations,
            reelStopSymbols: generationsData[generationsData.length - 1].originalSymbols, // first gen
            reelFinalSymbols: generationsData[generationsData.length - 1].originalSymbols, // last gen
            tempWinAmount: generationsData[generationsData.length - 1].generationWin,
            accumulatedWin: data.win,
            freespins: data.freespins,
            freespinsWon: data.freespins?.length || 0,
            overlays: data.freespins?.length > 0 ?
                this.parseOverlay(
                    generationsData[generationsData.length - 1].originalSymbols,
                    this.parseGenerationsSymbolsData(
                        Utils.deepClone(data.freespins[0].generations)
                    )
                )
                : undefined
        };
        // debugger
        // console.log(result.overlays, "overylayss")
        results.push(result);
        if (data.freespins) {

            data.freespins.forEach((spinData, index, arr) => {
                const fsGenerationsData = this.parseGenerationsSymbolsData(
                    Utils.deepClone(spinData.generations)
                );
                const currentSlice = fsGenerationsData.slice(currentGenerationIndex);
                let cascadesData: any[] = this.parseCascadeSpins(currentSlice, true);
                const parsed = {
                    isFree: true,
                    balance: data.stats ? data.stats.b : undefined,
                    winAmount: fsGenerationsData[fsGenerationsData.length - 1].generationWin,
                    currentWin: fsGenerationsData[fsGenerationsData.length - 1].generationWin,
                    winsData: this.parseWinData(
                        spinData.generations[spinData.generations.length - 1].winnings
                    ),
                    ended: data.ended, // round ended
                    multiplier: spinData.generations[fsGenerationsData.length - 1].multiplier,
                    stopPositions: [0, 0, 0, 0, 0, 0, 0, 0], // reel stop position
                    cascades: cascadesData.slice(0, fsGenerationsData.length - 1),
                    cascadeIndex: cascadesData?.length > 0 ? 0 : -1,
                    // cascadeWinOffsets:cascadesData && cascadesData.length?cascadesData[cascadesData.length - 1].cascadeWinOffsets:[],
                    cascadeWinOffsets: [],
                    generations: spinData.generations,
                    reelStopSymbols: fsGenerationsData[fsGenerationsData.length - 1].originalSymbols, // first gen
                    reelFinalSymbols: fsGenerationsData[fsGenerationsData.length - 1].originalSymbols, // last gen
                    tempWinAmount: fsGenerationsData[fsGenerationsData.length - 1].generationWin,
                    accumulatedWin: fsGenerationsData[fsGenerationsData.length - 1].generationWin,
                    spinsLeft: spinData.spinsLeft,
                    freespinsNum: spinData.spinsLeft,
                    overlays: data.freespins?.length > 0 ?
                        this.parseOverlay(
                            fsGenerationsData[fsGenerationsData.length - 1].originalSymbols,
                            this.parseGenerationsSymbolsData(
                                Utils.deepClone(arr[index + 1]?.generations)
                            )
                        )
                        : undefined
                }

                results.push(parsed);
            });

        }

        console.warn("RESULT:", results);

        return results;
    }
    parseOverlay(originalSymbols: any, nextOriginalSymbols?: any): any {
        if (nextOriginalSymbols === undefined) {
            return
        }
        const clone = Utils.deepClone(originalSymbols);
        const cloneNext = Utils.deepClone(nextOriginalSymbols[0].originalSymbols);
        let result = []
        let wilds = []
        for (let i = 0; i < clone.length; i++) {
            for (let j = 0; j < clone[i].length; j++) {
                if (clone[i][j] != 0) {
                    clone[i][j] = null;
                } else {
                    wilds.push({
                        reel: i,
                        row: j
                    })
                }
            }
        }

        let lockedObj = {
            type: OverlayType.Locked,
            symbolPosition: clone,
        }
        result.push(lockedObj);

        let path: ISymbolPosition[] = [];

        for (let i = 0; i < cloneNext.length; i++) {
            for (let j = 0; j < cloneNext[i].length; j++) {
                if (cloneNext[i][j] == 0) {
                    path.push({
                        reel: i,
                        row: j
                    })

                }
            }
        }

        let movingObj = {
            type: OverlayType.Moving,
            symbolPosition: clone,
            path: path
        }

        result.push(movingObj);

        return result;
    }

    parseCascadeSpins(cascadeSpins: any, hasFreeSpins: boolean): any[] {
        // debugger
        // console.log(cascadeSpins);
        // debugger
        if (!cascadeSpins) {
            return [];
        }

        if (cascadeSpins.length === 1) {
            return [];
        }


        // If single item - convert to 1-item array for easier parsing
        if (!Array.isArray(cascadeSpins)) {
            cascadeSpins = [cascadeSpins];
        }

        let cascades = [];

        cascadeSpins.forEach((cascade, index) => {
            if (hasFreeSpins) {
                if (cascade.generationWin > 0 || cascade.destroyedXPositions) {
                    let parsedCascade = this.parseCascadeObject(cascade);
                    cascades.push(parsedCascade);
                }
            } else {
                let parsedCascade = this.parseCascadeObject(cascade);
                cascades.push(parsedCascade);
            }
        });

        return cascades;
    }
    calculateWinOffset(winnings, symbols: number[][]): any {
        if (winnings && winnings[0]) {
            // return winnings[0].winSymbols*8 + winnings[0].win;
            let winOffset = [];
            winnings.forEach(winnig => {

                winnig.winSymbols.forEach((row, index) => {
                    let reel = winnig.winReels[index];
                    let pos = row * 8 + reel;
                    if (!winOffset.includes(pos) && symbols[reel][row] != 0) {
                        winOffset.push(row * 8 + reel);
                    }
                });
            });
            return winOffset;

        } else {
            return [];
        }
    }

    calculateExplosionsOffset(explosions): any {

        if (explosions && explosions[0]) {
            let winOffset = [];
            explosions.forEach(exlosion => {
                let pos = (exlosion.y - 1) * 8 + (exlosion.x - 1);
                if (!winOffset.includes(pos)) {
                    winOffset.push(pos);
                }
            });
            return winOffset;

        } else {
            return [];
        }
    }

    parseCascadeObject(cascade): any {

        let winsData = this.parseWinData(
            cascade.winnings
        );
        let cascadeWinOffsets = this.calculateWinOffset(Utils.deepClone(winsData), Utils.deepClone(cascade.symbols));
        let cascadeExplodesOffsets = this.calculateExplosionsOffset(Utils.deepClone(cascade.destroyedXPositions));
        const result = {
            winAmount: cascade.generationWin,
            currentWin: cascade.generationWin,
            accumulatedWin: cascade.generationWin,
            winsData,
            ended: cascade.ended, // round ended
            multiplier: cascade.multiplier,
            stopPositions: [0, 0, 0, 0, 0, 0, 0, 0], // reel stop position
            cascadeIndex: -1,
            cascadeWinOffsets: cascadeWinOffsets,
            cascadeExplodesOffsets,
            reelStopSymbols: cascade.symbols, // first gen
            reelFinalSymbols: cascade.symbols, // last gen
            tempWinAmount: cascade.generationWin,
            freespins: cascade.freespins,
            transform: cascade.transform
        };

        //console.log(result);

        return result;

    }

    parseGenerationsSymbolsData(generationData): any[] {
        if (generationData) {
            let i: number;
            const genDataLen = generationData.length;
            for (i = 0; i < genDataLen; i++) {
                generationData[i].index = i;
                generationData[i].ended = i === genDataLen - 1;
                generationData[i].removedSymbols = Utils.deepClone(generationData[i].destroyedXPositions);
                generationData[i].symbols = SymbolMap.parseSymbols(
                    generationData[i].originalSymbols
                );
                generationData[i].originalSymbols = SymbolMap.parseSymbols(
                    generationData[i].originalSymbols
                );
                // generationData[i].symbols.forEach( reel =>{
                //     reel.push(0);
                //     reel.unshift(0);
                // })
                generationData[i].generationWin = this.calculateGenWin(
                    generationData[i].winnings
                );
                generationData[i].transformation = generationData[i].transform
            }
            return generationData;
        }
    }

    public parseWinData(winData) {
        const winsData = [];
        for (let i = 0; i < winData.length; i++) {
            winsData.push({
                type: winData[i][0],
                isWay: winData[i][0] == "normal",
                normalLineWin: true,
                creditsWon: winData[i][2],
                winSymId: SymbolMap.parseSymbols([winData[i][4]])[0],
                lineId: winData[i][1], // starts from 1
                multiplier: winData[i][5],
                coordinates: winData[i][3],
                winReels: this.resolveWinCoords(true, winData[i][3]),
                winSymbols: this.resolveWinCoords(false, winData[i][3]),
            });
        }
        return winsData;
    }

    resolveWinCoords(reels, data: { x: number; y: number }[]) {
        let coord = reels ? "x" : "y";
        let result = [];
        for (let i = 0; i < data.length; i++) {
            result.push(data[i][coord] - 1); // -1 because relax counts from 1
        }
        return result;
    }

    calculateGenWin(winData) {
        let winning = 0;
        for (let i = 0; i < winData.length; i++) {
            if (winData[i][0] != "freespins") {
                winning += winData[i][2];
            }
        }
        return winning;
    }


}
